import me from '@/api/apiSferest/services/me'
import sign from '@/api/apiSferest/services/sign'

/**
 * Set Me information
 * @param {Object} payload - Me Object information.
 */
export const set = ({ commit, dispatch, state }, payload) => {
  return new Promise((resolve, reject) => {
    commit('SET_ID', payload.id)
    commit('SET_TYPE', payload.type)
    commit('SET_RESIDENCE', payload.residence)
    commit('SET_TRADENAME', payload.tradeName)
    commit('SET_NAME', payload.name)
    commit('SET_LASTNAME', payload.lastName)
    commit('SET_DOCUMENT', payload.document)
    commit('SET_ISSUED_INVOICES', payload.issuedInvoices)
    commit('SET_MAX_INVOICES', payload.maxIssuedInvoices)
    if (payload.settings) {
      commit('SET_MERCANTILEREGISTRY', payload.settings.mercantileRegistry)
      commit('SET_ACCOUNTASSIGNEDID', payload.settings.accountAssignedId)
      commit('SET_IRPF', payload.settings.irpf)
      commit('SET_GREENPOINT', payload.settings.greenPoint)
      commit('SET_REGIME', payload.settings.specialRegime)
      commit('SET_TICKETBAIREQUIRED', payload.settings.ticketbaiRequired)
      commit('SET_SIIREQUIRED', payload.settings.siiRequired)
      commit('SET_HEADINGBIZKAIA', payload.settings.headingBizkaia)
      commit('SET_VERIFACTU', payload.settings.verifactu)
      commit('SET_VERIFACTU_EXEMPTION_TEXT', payload.settings.verifactuExemptionText)
      commit('SET_VERIFACTU_SELECTED_DATE', payload.settings.verifactuSelectedDate)
    }
    Promise.all([
      ...['address', 'contactMedium']
      .filter(k => !!payload[k])
      .map(k => {
        return dispatch(`${k}/set`, payload[k])
      })
    ]).then(() => {
      resolve(state)
    })
  })
}

export const get = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    me.get()
    .then((res) => {
      dispatch('set', res.data)
      .then(contact => resolve(contact))
    })
    .catch((e) => {
      reject(new Error(e))
    })
  })
}

export const getTermsAndConditions = ({ commit }) => {
  return new Promise((resolve, reject) => {
    sign.terms()
    .then((res) => {
      commit('SET_TERMS_AND_CONDITIONS', res.data.description)
      resolve()
    })
    .catch((e) => {
      reject(new Error(e))
    })
  })
}

export const update = ({dispatch, getters}) => {
  return new Promise((resolve, reject) => {
    const config = getters.apificate
    me.update(config)
    .then((res) => {
      dispatch('get')
      .then(data => resolve(data))
    }, err => {
      reject(new Error(err))
    })
  })
}
